import { REACTION } from "../apiConstant";
import BaseApi from "../baseApi";

class ReactionApi extends BaseApi {
  getReaction(param) {
    return this.post(`${REACTION}/${param?.requestUuid}`, param);
  }
}
export default ReactionApi;
